import React from 'react';
import signatureModalContext from 'common/signature-modal/context';
import styles from './signature.scss';

function Signature({
  fieldData,
  height,
  width,
  textScale,
  validationErrors,
  getInstantValidationErrorHack,
  selectField,
  updateFields,
  isActive,
  ...props
}, ref) {
  const signatureProps = React.useContext(signatureModalContext);
  if (fieldData.signature != null) {
    const src = signatureProps.getSignatureUrl(fieldData.signature);
    const style = {
      height: '100%',
      width: '100%',
      cursor: 'auto',
    };


    return (
      <div style={style} ref={ref} {...props}>
        <img className={styles.image} src={src} />
      </div>
    );
  }
  return null;
}

export default React.forwardRef(Signature);
